export default "__VITE_ASSET__BZcBNLGf__"